import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";

/** Number of rows to show in sidebar */
const NUMBER_OF_ROWS = 3;

/**
 * Renders a skeleton loading component for CardSelector component from flat-ui.
 * https://storybook.dev.holobuilder.com/flat-ui/?path=/docs/unstable-cardselector-cardselector--docs
 *
 * @returns {JSX.Element} The CardSelectorSkeleton component.
 */
export function CardSelectorSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>{[...Array(NUMBER_OF_ROWS)].map(_temp)}</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return <Skeleton key={index} variant="rectangular" sx={{
    width: "100%",
    height: "104px",
    mb: "10px"
  }} />;
}